import { getItem, removeItem, setItem } from 'mini-localstorage';

export const SELECTED_CALENDARS_KEY = 'selectedCals';
/**
 * Adds calendar folder id to local storage
 * @param folderId
 */
export function addCalendarFolderIdToLocalStorage(folderId: string) {
    const selectedCalendars = getItem(SELECTED_CALENDARS_KEY) || [];
    if (selectedCalendars.indexOf(folderId) === -1) {
        selectedCalendars.push(folderId);
        setItem(SELECTED_CALENDARS_KEY, selectedCalendars);
    }
}

/**
 * Removes calendar folder id from local storage
 * @param folderId
 */
export function removeCalendarFolderIdFromLocalStorage(folderId: string) {
    const selectedCalendars = getItem(SELECTED_CALENDARS_KEY) || [];
    const indexToRemove = selectedCalendars.indexOf(folderId);
    if (indexToRemove !== -1) {
        selectedCalendars.splice(indexToRemove, 1);
        setItem(SELECTED_CALENDARS_KEY, selectedCalendars);
    }
}

export function clearAllSelectedCalendarFolderId() {
    removeItem(SELECTED_CALENDARS_KEY);
}
